import { lazy } from 'react';

/**
 * A `lazy()` wrapper only, so the barrel can export it statically: `useDocuments` and
 * `useIsPresentationTool` have no lazy boundary inside `@sanity/visual-editing/react` itself, and
 * pull in its largest chunk. The implementation loads on first render, which `CmsRouteContainer`
 * only reaches in draft mode.
 */
export const SlotAdderBridge = lazy(() => import('./slot-adder-bridge-impl'));
